<i18n src="./translations"></i18n>

<template>
  <PdpTabBase
    class="pdp-vehicle-types-tab"
    :headline="$t('pdp-vehicle-types-tab.headline')"
    :class="classes"
    :data-preload="[$options.name]"
    :is-expanded="activeTab"
  >
    <PdpCarTypesTable :product-id="productId" />
  </PdpTabBase>
</template>

<script>
import PdpTabBase from 'Components/01-atoms/pdp-tab-base/PdpTabBase';
import globalMixin from 'Libs/mixins/globalMixin';
import PdpCarTypesTable from 'Components/02-molecules/product-info-sections/subcomponents/PdpCarTypesTable.vue';

export default {
  name: 'PdpVehicleTypesTab',
  components: { PdpTabBase, PdpCarTypesTable },
  mixins: [globalMixin],
  props: {
    productId: {
      type: String,
      required: true,
    },
    activeTab: {
      type: Boolean,
      default: false,
    },
    hasCarTypes: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

::v-deep {
  .pdp-vehicle-types-tab__row-modifier {
    display: flex;
    align-items: center;
    gap: var(--space-1);

    .pdp-vehicle-types-tab__row-modifier-label {
      font-size: 16px;
      line-height: 22px;
      font-weight: bold;
    }

    .icon {
      color: var(--color-kfzteile24-semantic-green);
    }
  }

  .pdp-table__table-cell:not(.pdp-table__table-cell--slot-cell) {
    padding-top: var(--space-1--half) !important;
    padding-bottom: var(--space-1--half) !important;
  }
}
</style>
